export let props = ['title', 'timeStart', 'timeEnd', 'close', 'preIcon', 'small', 'clearable','timeFrame'];
export let model = {
  preTimeStart: undefined,
  preTimeEnd: undefined
};
export let computed = {
  currentTimeStart: {
    get() {
      return this.timeStart;
    },
    set(val) {
      if(this.timeFrame &&this.currentTimeEnd){
        var day=parseInt(Math.abs(new Date(val).getTime() - new Date(this.currentTimeEnd).getTime() ) / 1000 / 60 / 60 /24);
        if(day >30){
          this.$message({
            message: '时间范围不可超过30天',
            type: 'warning'
          })
          var date1 = new Date(val)
          var date2 = new Date(date1);
          date2.setDate(date1.getDate() + 29);
          var endTime = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate() + ' 23:59:59'
          console.log(endTime);
          this.$emit('update:timeEnd', endTime);
        }
      }
      if (val && this.currentTimeEnd && new Date(val).getTime() > new Date(this.currentTimeEnd).getTime()) {
        // 修改逻辑为起始时间小于结束时间时，就将结束时间按照现在+1天
        const start = new Date(val);
        this.$emit('update:timeEnd', start.format('yyyy-MM-dd') + ' 23:59:59');
        // this.$message({
        //   message: '开始时间不能大于结束时间！',
        //   type: 'warning'
        // })
        // this.$emit('update:timeStart', new Date(this.currentTimeEnd).format('yyyy-MM-dd hh:mm:ss'));
        this.$emit('update:timeStart', new Date(val).format('yyyy-MM-dd hh:mm:ss'));
      } else if (val && !this.currentTimeEnd) {
        this.$emit('update:timeStart', new Date(val).format('yyyy-MM-dd hh:mm:ss'));
        this.$emit('update:timeEnd', new Date(val).format('yyyy-MM-dd') + ' 23:59:59');
      } else {
        this.$emit('update:timeStart', new Date(val).format('yyyy-MM-dd hh:mm:ss'));
      }
    }
  },
  currentTimeEnd: {
    get() {
      return this.timeEnd;
    },
    set(val) {
      if(this.timeFrame &&this.currentTimeEnd){
        var day=parseInt(Math.abs(new Date(val).getTime() - new Date(this.currentTimeStart).getTime() ) / 1000 / 60 / 60 /24);
        if(day >30){
          this.$message({
            message: '时间范围不可超过30天',
            type: 'warning'
          })
          var date1 = new Date(val)
          var date2 = new Date(date1);
          date2.setDate(date1.getDate() - 29);
          var startTime = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate() + ' 00:00:00'
          console.log(startTime);
          this.$emit('update:timeStart', startTime);
        }
      }
      if (val && this.currentTimeStart && new Date(val).getTime() < new Date(this.currentTimeStart).getTime()) {
        const end = new Date(val);
        this.$emit('update:timeStart', end.format('yyyy-MM-dd' + ' 00:00:00'));
        // this.$message({
        //   message: '结束时间不能小于开始时间！',
        //   type: 'warning'
        // })
        // this.$emit('update:timeEnd', new Date(this.currentTimeStart).format('yyyy-MM-dd hh:mm:ss'));
        this.$emit('update:timeEnd', new Date(val).format('yyyy-MM-dd hh:mm:ss'));
      } else if (val && !this.currentTimeStart) {
        this.$emit('update:timeStart', new Date(val).format('yyyy-MM-dd' + ' 00:00:00'));
        this.$emit('update:timeEnd', new Date(val).format('yyyy-MM-dd hh:mm:ss'));
      } else {
        this.$emit('update:timeEnd', new Date(val).format('yyyy-MM-dd hh:mm:ss'));
      }
    }
  }
};
